<template>
  <div class="decision-test">
    <div v-if="work">
      <div v-for="(variant, key) in work.metadata.variants" :key="`variant-key-${key}`">
        <div v-for="(answer, key2) in variant.answers" :key="`answer-key-${key2}`">
          <div>
            {{ answer.title }}
            <img v-if="answer.img" :src="answer.img" />

            <span v-if="answer.is_true === true">Правильный ответ</span>
            <span v-else>Неправильный ответ</span>
            <span v-if="check(answer)" class="ml-2 mr-2 badge badge-info"> ответ ученика</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "dropdown",
  props: {
    work: {
      default: null,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    check(answer) {
      for (let i = 0; i < this.work.decisions.length; i++) {
        if (this.work.decisions[i].answer == answer.title) {
          return true;
        }
      }
    }
  },
};
</script>


<style lang="scss">
.decision-test {
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    margin-right: 10px;
  }
}
</style>

